function reducer(state,action){
 switch(action.type){
    case "incrementbyf":
        return {
            ...state,
            amount:state.amount+action.payload
        };
    case "deccrementbyf":
            return {
                ...state,
                amount:state.amount-action.payload
            };
    case "incrementbyt":
        return {
            ...state,
            amount:state.amount+action.payload
        };
    
    case "deccrementbyt":
        return {...state,amount:state.amount-action.payload}
    default:
        return state
 }
}

export default reducer